import type { ReactNode } from 'react'
import { Search } from 'lucide-react'
import { cn } from '../lib/cn'

export interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  right?: ReactNode
}

export function SearchInput({ value, onChange, placeholder, className, right }: SearchInputProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-lg border border-neutral-200 px-3 py-2 focus-within:border-brand-300',
        className,
      )}
    >
      <Search className="h-4 w-4 shrink-0 text-neutral-400" />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="min-w-0 flex-1 bg-transparent text-sm text-neutral-800 placeholder:text-neutral-400 focus:outline-none"
      />
      {right}
    </div>
  )
}
